import { Component, Input } from '@angular/core';
import { Report } from '../../../models/report.model';

@Component({
  selector: 'app-notes-read-mode',
  templateUrl: './notes-read-mode.component.html',
  styleUrls: ['./notes-read-mode.component.scss'],
})
export class NotesReadModeComponent {
  @Input() notes!: Report.Notes;
}
